import { NotifyHelper } from 'classes/helpers/notify.helper';
import { t } from 'i18next';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { AdminVisionDetectionsRoutes } from 'lib_ts/enums/routing/routes/admin-vision-detections';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import {
  IMissedDetectionsHistoryQuery,
  IMissedDetectionsHistoryWithTotal,
} from 'lib_ts/interfaces/data/i-machine-shot-history';
import { IVisionDetection } from 'lib_ts/interfaces/vision/i-vision-detection';
import { BaseRESTService } from 'services/_base-rest.service';

export class AdminVisionDetectionsService extends BaseRESTService {
  private static instance: AdminVisionDetectionsService;

  static getInstance(): AdminVisionDetectionsService {
    if (!AdminVisionDetectionsService.instance) {
      AdminVisionDetectionsService.instance =
        new AdminVisionDetectionsService();
    }

    return AdminVisionDetectionsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.AdminVisionDetections,
    });
  }

  async getMissedDetectionsHistory(
    payload: IMissedDetectionsHistoryQuery
  ): Promise<IMissedDetectionsHistoryWithTotal> {
    return await this.post(
      {
        uri: `${AdminVisionDetectionsRoutes.GetMissedDetectionsHistory}/${payload.machineID}`,
      },
      payload
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md:
              result.error ??
              'There was an error while fetching missed detections history.',
          });
          return {
            data: [],
            total: 0,
          };
        }

        return result.data as IMissedDetectionsHistoryWithTotal;
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md:
            'There was an error while fetching missed detections history.',
        });
        return {
          data: [],
          total: 0,
        };
      });
  }

  async getById(id: string): Promise<IVisionDetection | undefined> {
    return await this.get({
      uri: `${AdminVisionDetectionsRoutes.GetOne}/${id}`,
    })
      .then((result) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md: result.error ?? t('common.request-failed-msg'),
          });
          return undefined;
        }

        return result.data as IVisionDetection;
      })
      .catch((e) => {
        console.error(e);
        return undefined;
      });
  }

  async getByFireID(fireID: string): Promise<IVisionDetection | undefined> {
    return await this.get({
      uri: `${AdminVisionDetectionsRoutes.GetByFireID}/${fireID}`,
    })
      .then((result) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md: result.error ?? t('common.request-failed-msg'),
          });
          return undefined;
        }

        return result.data as IVisionDetection;
      })
      .catch((e) => {
        console.error(e);
        return undefined;
      });
  }
}
